<div class="">
  <div class="flex footer-wrapper">

    <ul>
      @if (!hideTogglePanes) {
        <li [ngClass]="{'active': panesLimit, 'always-on-screen': panesLimit}" class="hide-on-mobile" >
          <a [asgClickHandler]="togglePanes"
            asgTooltip="BOTTOMBAR.TOOGLE_PANES"><i class="icon-split"></i></a>
          </li>
        }
      </ul>

      <span class="spacer"></span>

      <ul>
        <li>
          <!-- <a href="https://sensotec.be/" target="_blank"> -->
            @if (this.currentTheme === lightDarkThemes.Light) {
              <img [src]="isK3000 ? 'assets/images/sensotec-logo-dark.svg' : 'assets/images/alinea-logo-light.svg'"  alt="Logo Sensotec"
                width="60" />
            }
            @if (this.currentTheme === lightDarkThemes.Dark) {
              <img [src]="isK3000 ? 'assets/images/sensotec-logo-light.png' : 'assets/images/alinea-logo-dark.svg'" alt="Logo Sensotec"
                width="60" />
            }
          <!-- </a> -->
        </li>
      </ul>
    </div>
  </div>

